// removed by extract-text-webpack-plugin
module.exports = {"OneColumnLayout":"OneColumnLayout","OneColumnLayout__resetUpperMargin":"OneColumnLayout__resetUpperMargin","OneColumnLayout__setLowerMargin":"OneColumnLayout__setLowerMargin","OneColumnLayout__nested":"OneColumnLayout__nested","OneColumnLayout__container":"OneColumnLayout__container","OneColumnLayout__column":"OneColumnLayout__column","size__divider":"size__divider","size__gutter":"size__gutter","size__vertical-padding":"size__vertical-padding","size__horizontal-padding":"size__horizontal-padding","size__padding":"size__padding","_modal-open":"_modal-open"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/one-column-layout/styles.css
// module id = 803
// module chunks = 0 1